export const isPrimitive = (
  value: unknown,
): value is string | number | boolean | bigint | symbol => {
  const type = typeof value;
  return (
    type === "string" ||
    type === "number" ||
    type === "boolean" ||
    type === "bigint" ||
    type === "symbol"
  );
};
